import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'antd';

interface Props {
	translateKey?: string;
	badgeText?: string | number;
}

export const TabLabel = ({ translateKey, badgeText }: Props) => {
	const { t } = useTranslation();

	return (
		<Badge count={badgeText} size="small" className="alerts-count-badge">
			{t(translateKey)}
		</Badge>
	);
};
